import styled from "@emotion/styled";
import IcoMoon from "react-icomoon";
import PropTypes from "prop-types";
import React from "react";

const iconSet = require("~/assets/icomoon/selection.json");

const Icon = styled(IcoMoon)`
    color: ${({ theme, color }) => theme.palette[color]}}
`;

const IcoIcon = ({
    color,
    icon,
    size = 25,
    style,
    className,
    disableFill,
    removeInlineStyle,
}) => {
    return (
        <Icon
            {...{
                color,
                iconSet,
                icon,
                size,
                style,
                className,
                disableFill,
                removeInlineStyle,
            }}
            aria-hidden={true}
        />
    );
};

IcoIcon.propTypes = {
    color: PropTypes.string,
    iconSet: PropTypes.shape({}),
    icon: PropTypes.string,
    size: PropTypes.number,
    style: PropTypes.shape({}),
    className: PropTypes.string,
    disableFill: PropTypes.bool,
    removeInlineStyle: PropTypes.bool,
};

export default IcoIcon;
